<div class="error" *ngIf="message !== undefined">
    {{message}}
</div>
<div class="error" *ngIf="message === undefined">&nbsp;</div>
